// extracted by mini-css-extract-plugin
export default {"inputContainer":"axnui-date-input__input-container__cATEg","helpText":"axnui-date-input__help-text__TIJSO"};